module.exports = require('react-router');
module.exports.routerRedux = require('react-router-redux');



//////////////////
// WEBPACK FOOTER
// ./~/dva/router.js
// module id = 294
// module chunks = 0